<template>
  <TableGradient
      icon-name="folder"
      :title="$t('protocol.listagem.titulo_pagina')"
      :text-empty="$t('protocol.listagem.table.empty')"
      route-new="vns.protocol.create"
      :text-new="$t('protocol.listagem.novo')"
      :fields="fields"
      :fields-filter="filter"
      :items="protocols"
      :paginator="paginator"
      :loading="isLoading"
      @list="evt => $store.dispatch('protocol/listAll', evt)"
      table-data>
    <template v-slot:cell(id)="linha">
      <router-link :id="`link-edit-${linha.index}`" :to="{ name: 'vns.protocol.edit', params: { id: linha.item.id }}"
                   class="font-weight-bold">
        {{ $t('protocol.listagem.table.editar') }}
      </router-link>
    </template>
    <template v-slot:cell(status)="linha">
      <span
          :class="{'rounded-pill p-1 ':true, 'badge badge-success':linha.item.status, 'badge badge-danger': !linha.item.status}">
          <i :class="linha.item.status ? 'fas fa-check' : 'fas fa-ban'"/>
      </span>
    </template>
  </TableGradient>
</template>

<script>
import TableGradient from "@/templates/TableGradient";
import {mapActions, mapGetters} from 'vuex'

export default {
  name: "Index",
  components: {TableGradient},
  computed: {
    ...mapGetters({
      protocols: 'protocol/all',
      paginator: 'protocol/pagination',
      store_isLoading: 'protocol/isLoading'
    }),
    isLoading() {
      return !(this.mounted && this.store_isLoading === false)
    }
  },
  data() {
    return {
      mounted: false,
      fields: [
        {key: 'name', label: this.$t('protocol.listagem.table.nome'), sortable: true},
        {key: 'class', label: this.$t('protocol.listagem.table.classe'), sortable: true},
        {key: 'status', label: 'Status', sortable: true},
        {key: 'id', label: this.$t('protocol.listagem.table.editar')}
      ],
      filter: [
        {key: 'name', label: this.$t('protocol.listagem.table.nome')},
        {key: 'class', label: this.$t('protocol.listagem.table.classe')},
      ]
    }
  },
  methods: {
    ...mapActions([
      'protocol/listAll'
    ])
  },
  mounted() {
    this['protocol/listAll'](this.paginator)
    this.mounted = true
  }
}
</script>

<style lang="scss" scoped>
</style>
